import React, { useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Breadcrumbs } from "../../view/Navigation/BreadCrumbs";
import { ApplicationContext } from "../../components/ApplicationProvider";
import { StyledDevices, ContentContainer, Header } from "./Devices.styles";
import DeviceTabs, { DeviceTab } from "./DeviceTabs/DeviceTabs";
import Printers from "./Printers/Printers";
import Gateways from "./Gateways/Gateways";
import useGatewayManager from "./Gateways/GatewayOperations/useGatewayManager";

const DEFAULT_DEVICE_TAB = DeviceTab.Printers;

function getActiveTab(search: string, isCSE: boolean): DeviceTab {
    if (isCSE) {
        return DeviceTab.Gateways;
    }

    const params = new URLSearchParams(search);
    const tab = params.get("tab");

    return tab === DeviceTab.Gateways ? DeviceTab.Gateways : DEFAULT_DEVICE_TAB;
}

const Devices: React.FC = () => {
    const { t } = useContext(ApplicationContext);
    const history = useHistory();
    const location = useLocation();

    const { isCSE } = useGatewayManager();
    const activeTab = getActiveTab(location.search, isCSE);

    const handleTabChange = (tab: DeviceTab): void => {
        const params = new URLSearchParams(location.search);

        if (tab === DEFAULT_DEVICE_TAB) {
            params.delete("tab");
        } else {
            params.set("tab", tab);
        }

        history.replace({
            pathname: location.pathname,
            search: params.toString() ? `?${params.toString()}` : "",
        });
    };

    return (
        <StyledDevices>
            <Header>
                <Breadcrumbs
                    sections={[
                        {
                            label: "Devices",
                        },
                    ]}
                />
                <h2 className="page-header">{t("devices.breadcrumb")}</h2>
            </Header>

            <ContentContainer>
                <DeviceTabs activeTab={activeTab} onChange={handleTabChange} isCSE={isCSE} />
                {activeTab === DeviceTab.Printers && <Printers />}
                {activeTab === DeviceTab.Gateways && <Gateways />}
            </ContentContainer>
        </StyledDevices>
    );
};

export default Devices;
